'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowTitle = function () {
    function WindowTitle(state) {
        var _this = this;

        (0, _classCallCheck3.default)(this, WindowTitle);

        this.state = state;
        this.title = state.settings.windowTitle || '';
        this.alert = false;

        if (state.settings.windowTitle) {
            this.updateTitle();
        }

        state.$watch('settings.windowTitle', function (newVal) {
            _this.updateTitle(newVal);
        });

        state.$watch('ui.app_has_focus', function (newVal) {
            if (newVal && _this.alertTmr) {
                _this.stopAlert();
            }
        });

        state.$on('notification.title', function (enable) {
            if (enable) {
                _this.startAlert();
            } else {
                _this.stopAlert();
            }
        });
    }

    (0, _createClass3.default)(WindowTitle, [{
        key: 'startAlert',
        value: function startAlert() {
            var _this2 = this;

            if (this.alertTmr) {
                return;
            }

            this.alertTmr = setInterval(function () {
                _this2.updateTitle();
            }, 1000);
        }
    }, {
        key: 'stopAlert',
        value: function stopAlert() {
            if (this.alertTmr) {
                clearInterval(this.alertTmr);
                this.alertTmr = null;
            }

            this.updateTitle();
        }
    }, {
        key: 'updateTitle',
        value: function updateTitle(newTitle) {
            if (typeof newTitle === 'string') {
                this.title = newTitle;
            }

            if (this.alertTmr && !this.alert) {
                window.document.title = '* ' + this.title;
                this.alert = true;
            } else {
                window.document.title = this.title;
                this.alert = false;
            }
        }
    }]);
    return WindowTitle;
}();

exports.default = WindowTitle;


//////////////////
// WEBPACK FOOTER
// ./src/libs/WindowTitle.js
// module id = 7hSk
// module chunks = 1